import React, { useState, useEffect } from "react";
import {
  ChevronDown,
  ChevronRight,
  Edit2,
  Save,
  X,
  Search,
} from "lucide-react";
import { getToken } from "../auth/authConfig";
import axios from "axios";

const FormViewDetails = ({ formDetails, getFormInformation }) => {

  console.log("Form Details:", formDetails);
  const [expandedSections, setExpandedSections] = useState({
    unitDetails: false,
    auditDetails: false,
    protocolDetails: false,
    scoringDetails: false,
  });

  const [editModal, setEditModal] = useState({
    isOpen: false,
    title: "",
    currentValue: "",
    fieldName: "",
    fieldType: "text",
    options: [],
  });
  const [viewFormData, setViewFormData] = useState(null);
  const [groupName, setGroupName] = useState(localStorage.getItem("GroupName"));
  const [visible, setVisible] = useState(false);
  const [loading, setloading] = useState(false);
  // Sample options for multi-select fields
  const getFieldOptions = (fieldName) => {
    const optionsMap = {
      certifications: [
        "ISO 22000: 2018 Food Safety Management Systems",
        "ISO 9001: 2015 Quality Management Systems",
        "FSSC 22000 Food Safety System Certification",
        "BRC Global Standard for Food Safety",
        "SQF Food Safety Code",
        "IFS Food Standard",
        "HACCP Certification",
        "Organic Certification",
        "Halal Certification",
        "Kosher Certification",
      ],
      audit_criteria: [
        "ISO 22000: 2018 Food Safety Management Systems",
        "ISO 9001: 2015 Quality Management Systems",
        "FSSC 22000 Food Safety System Certification",
        "BRC Global Standard for Food Safety",
        "SQF Food Safety Code",
        "IFS Food Standard",
        "HACCP Standard",
        "Mars QMS Requirements",
        "Customer Specific Requirements",
        "Regulatory Requirements",
      ],
      audit_type: ["Sustaining", "Gap Assessment"],
      is_fssc_conjunction: ["Yes", "No"],
    };

    return optionsMap[fieldName] || [];
  };

  // const formatDate = (dateString) => {
  //   if (!dateString) return "N/A";

  //   const date = new Date(dateString);
  //   if (isNaN(date.getTime())) return "Invalid Date";

  //   const day = date.getDate();
  //   const month = date.toLocaleString("en-US", { month: "long" });
  //   const year = date.getFullYear();

  //   const getOrdinal = (num) => {
  //     if (num > 3 && num < 21) return "th";
  //     switch (num % 10) {
  //       case 1:
  //         return "st";
  //       case 2:
  //         return "nd";
  //       case 3:
  //         return "rd";
  //       default:
  //         return "th";
  //     }
  //   };

  //   return `${day}${getOrdinal(day)} ${month} ${year}`;
  // };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";

    const date = new Date(dateString + "T00:00:00Z"); // force UTC midnight
    if (isNaN(date.getTime())) return "Invalid Date";

    const day = date.getUTCDate();
    const month = date.toLocaleString("en-US", { month: "long", timeZone: "UTC" });
    const year = date.getUTCFullYear();

    const getOrdinal = (num) => {
      if (num > 3 && num < 21) return "th";
      switch (num % 10) {
        case 1: return "st";
        case 2: return "nd";
        case 3: return "rd";
        default: return "th";
      }
    };

    return `${day}${getOrdinal(day)} ${month} ${year}`;
  };


  function transformAuditData(input) {
    if (!input || Object.keys(input).length === 0) return {};
    const { areasOfConcern, ffscFindings, focusArea, protocolList } = input;

    // Extract and flatten all question objects from all subsections
    const protocolListArr = protocolList?.protocolFindings
      ? protocolList.protocolFindings.flatMap((pf) =>
        pf.subsection?.flatMap((sub) => sub.questions || []) || []
      )
      : [];

    // Return the new transformed object
    return {
      areasOfConcern,
      ffscFindings,
      focusArea,
      protocolListArr,
    };
  }

  function convertObjectStructure(inputObject) {
    // Define label mappings for common fields
    const labelMappings = {
      // Audit Details mappings
      form_id: "Form ID",
      cb_office_location: "CB Office Location",
      audit_language: "Audit Language",
      is_fssc_conjunction:
        "Will this be done in Conjunction with FSSC Certification Audit",
      audit_criteria:
        "Audit Criteria (Applicable Standard or Technical Specifications)",
      audit_start_date: "Audit Start Date",
      audit_end_date: "Audit End Date",
      audit_delivery: "Audit Delivery",
      audit_type: "Audit Type",
      version: "Version",
      audit_focus_area: "Audit Focus Area",
      audit_team: "Audit Team",
      activity: "Activity",
      correction_date: "Correction Date",
      lead_auditor: "Lead Auditor",
      lead_auditor_function: "Lead Auditor Function",

      // Scoring Details mappings
      conformanceLevel: "Mars QMS Audit Conformance Level",
      areaStrength: "Areas of Strength",
      areaOpportunity: "Areas of Opportunity",
      zeroFindingJustification: "If this audit had zero findings",
      auditDurationHour: "Audit duration (Hours)",
      auditDurationMinutes: "Audit duration Minutes",
      totalNonCorformanceScore: "Non Conformance Score",
      totalNonConformanceScore: "Non Conformance Score",
      minor: "Minors",
      major: "Majors",
      critical: "Criticals",
      minorScore: "Minor Score",
      majorScore: "Major Score",
      criticalScore: "Critical Score",

      // Unit Details mappings
      unitIndex: "Unit Index (3 Digit) and Unit Name",
      unitType: "Unit Type",
      manufacturingCode: "Manufacturing Code (3 Letter) (if applicable)",
      qualityManager: "Quality Manager or Lead Auditee",
      qualityManagerEmail: "Quality Manager or Lead Auditee Email",
      certifications: "Current Third Party Certifications Held",
      parentUnit: "Parent Unit Name",
      unitCountry: "Unit Country",
      unitRegion: "Unit Region",
      cbName: "CB Name",
      enterprise: "Enterprise",
      responsibleSegment: "Responsible Segment",
      responsibleDivision: "Responsible Division",
      businessUnit: "Business Unit",
      subBusinessUnit: "Sub Business Unit",

      // Off-site Fields mappings
      offSiteActivities: "Off-Site Activities (if applicable)",
      offsiteActivity: "Type of Off-Site Activity",
      locationAudited: "Is Location Currently Audited?",
      siteName: "Site Name",
      AuditingLocation: "If Yes - Who is Auditing Location",
    };

    // Helper function to generate label from key name
    function generateLabel(key) {
      if (labelMappings[key]) {
        return labelMappings[key];
      }
      // Convert snake_case or camelCase to Title Case
      return key
        .replace(/([A-Z])/g, " $1") // Add space before capital letters
        .replace(/_/g, " ") // Replace underscores with spaces
        .replace(/\b\w/g, (l) => l.toUpperCase()) // Capitalize first letter of each word
        .trim();
    }

    // Helper function to convert object to array format
    function convertToArrayFormat(obj, excludeKeys = []) {
      if (!obj || typeof obj !== "object") {
        return obj;
      }

      return Object.keys(obj)
        .filter((key) => !excludeKeys.includes(key))
        .map((key) => ({
          label: generateLabel(key),
          name: key,
          value: obj[key],
        }));
    }

    // Helper function to handle nested objects recursively
    function processNestedObject(obj) {
      if (!obj || typeof obj !== "object") {
        return obj;
      }

      if (Array.isArray(obj)) {
        return obj.map((item) => processNestedObject(item));
      }

      const result = {};

      for (const [key, value] of Object.entries(obj)) {
        // Handle specific known structures
        if (
          key === "auditDetails" &&
          typeof value === "object" &&
          !Array.isArray(value)
        ) {
          // Convert auditDetails object to array format
          result[key] = convertToArrayFormat(value);
        } else if (key === "scoringDetails" && typeof value === "object") {
          // Handle scoringDetails conversion - process each property individually
          result[key] = {};

          for (const [subKey, subValue] of Object.entries(value)) {
            if (
              subKey === "auditConclusion" &&
              typeof subValue === "object" &&
              !Array.isArray(subValue)
            ) {
              // Convert auditConclusion to "Audit Conclusion" array format
              result[key]["Audit Conclusion"] = convertToArrayFormat(subValue);
            } else if (
              (subKey === "qmsScore" || subKey === "fsscScore") &&
              Array.isArray(subValue)
            ) {
              // Handle qmsScore and fsscScore arrays - only convert objects within the array
              result[key][subKey] = subValue.map((scoreItem) => {
                if (
                  typeof scoreItem === "object" &&
                  !Array.isArray(scoreItem)
                ) {
                  return convertToArrayFormat(scoreItem);
                }
                return scoreItem;
              });
            } else if (Array.isArray(subValue)) {
              // Keep other arrays as is, don't process recursively
              result[key][subKey] = subValue;
            } else if (typeof subValue === "object" && subValue !== null) {
              // Process other nested objects
              result[key][subKey] = processNestedObject(subValue);
            } else {
              // Keep primitive values as is
              result[key][subKey] = subValue;
            }
          }
        } else if (key === "unitDetails" && typeof value === "object") {
          // Handle unitDetails structure - keep arrays intact
          result[key] = {};
          for (const [subKey, subValue] of Object.entries(value)) {
            if (Array.isArray(subValue)) {
              // Keep arrays in unitDetails as is
              result[key][subKey] = subValue;
            } else if (typeof subValue === "object" && subValue !== null) {
              result[key][subKey] = processNestedObject(subValue);
            } else {
              result[key][subKey] = subValue;
            }
          }
        } else if (Array.isArray(value)) {
          // For other arrays, only process if they contain objects that need conversion
          result[key] = value.map((item) => {
            if (typeof item === "object" && !Array.isArray(item)) {
              return processNestedObject(item);
            }
            return item;
          });
        } else if (typeof value === "object" && value !== null) {
          // Process nested objects recursively
          result[key] = processNestedObject(value);
        } else {
          // Keep primitive values as is
          result[key] = value;
        }
      }

      return result;
    }

    // Process the entire input object
    return processNestedObject(inputObject);
  }

  useEffect(() => {
    const versionItem =
      viewFormData &&
      viewFormData?.auditDetails?.find((item) => item.label === "Version");
    setVisible(versionItem?.value !== 1);
  }, [formDetails]);

  const toggleSection = (section) => {
    setExpandedSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  const getFieldType = (fieldName) => {
    if (fieldName.includes("email")) return "email";
    if (fieldName.includes("date")) return "date";
    if (["certifications", "audit_criteria"].includes(fieldName))
      return "multiselect";
    if (["audit_type", "is_fssc_conjunction"].includes(fieldName))
      return "select";
    if (fieldName === "audit_team") return "textarea";
    return "text";
  };

  const handleEdit = (title, currentValue, fieldName, sectionType) => {
    const fieldType = getFieldType(fieldName);
    const options = getFieldOptions(fieldName);

    // For multi-select fields, ensure currentValue is an array
    let processedValue = currentValue;
    if (fieldType === "multiselect") {
      if (typeof currentValue === "string") {
        processedValue = currentValue
          ? currentValue.split(",").map((item) => item.trim())
          : [];
      } else if (Array.isArray(currentValue)) {
        processedValue = currentValue;
      } else {
        processedValue = [];
      }
    }

    setEditModal({
      isOpen: true,
      title,
      currentValue: processedValue,
      fieldName,
      fieldType,
      options,
      sectionType,
    });
  };

  const handleSave = async (value) => {
    // Determine endpoint based on section type
    const endpoint =
      editModal.sectionType === "unitDetails"
        ? "/editform/unitdetails"
        : "/editform/auditDetails";

    const payload = {
      formId: viewFormData.formId,
      columnName: editModal.fieldName,
      value: value,
    };

    const url = `${process.env.REACT_APP_SERVER_URL}/super/${endpoint}`;
    setloading(true);
    try {
      const token = await getToken();
      const response = await axios.post(url, payload, {
        headers: {
          "oidc-token": token,
        },
      });
      console.log("API response:", response.data);
      setloading(false);
      getFormInformation(viewFormData.formId);
      // Optionally show success feedback to user here
    } catch (error) {
      console.error("Error saving data:", error);
      setloading(false);

      // Optionally show error feedback to user here
    }

    // Reset modal state
    setEditModal({
      isOpen: false,
      title: "",
      currentValue: "",
      fieldName: "",
      fieldType: "text",
      options: [],
    });
  };

  const AccordionSection = ({ title, sectionKey, children }) => (
    <div className="mb-4 bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
      <button
        onClick={() => toggleSection(sectionKey)}
        className="w-full px-6 py-4 bg-gradient-to-r from-teal-500 to-teal-500 text-white font-semibold text-left flex items-center justify-between hover:from-teal-700 hover:to-teal-800 transition-all duration-200"
      >
        <span>{title}</span>
        {expandedSections[sectionKey] ? (
          <ChevronDown
            size={20}
            className="transform transition-transform duration-200"
          />
        ) : (
          <ChevronRight
            size={20}
            className="transform transition-transform duration-200"
          />
        )}
      </button>

      {expandedSections[sectionKey] && (
        <div className="p-6 bg-gray-50">{children}</div>
      )}
    </div>
  );

  const renderTable = (data, sectionType = "") => (

    <div className="overflow-x-auto">
      <table className="min-w-full bg-white rounded-lg overflow-hidden shadow-sm">
        <thead className="bg-gray-100">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Field
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Response
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {data.map((row, index) => (
            <tr key={index} className="hover:bg-gray-50 transition-colors">
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                {row.label || row.name}
              </td>
              <td style={{ textTransform: "capitalize" }} className="px-6 py-4 text-sm text-gray-700">
                {row.label?.includes("Date") && row.value !== "NA" && row.value
                  ? formatDate(row.value)
                  : row.value === true
                    ? "Yes"
                    : row.value === false
                      ? "No"
                      : Array.isArray(row.value)
                        ? row.value.join(", ")
                        : row.value || "N/A"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  useEffect(() => {
    if (groupName === "Mars Admin") {
      setViewFormData(formDetails);
    } else {
      const protocolObj = transformAuditData(
        formDetails?.protocolDetails ?? {}
      );

      let resultedObj = convertObjectStructure(formDetails);
      const unwrapArray = (arr) => (Array.isArray(arr?.[0]) ? arr[0] : arr);

      // Apply it while building the result
      resultedObj = {
        ...resultedObj,
        scoringDetails: {
          ...resultedObj.scoringDetails,
          qmsScore: unwrapArray(resultedObj.scoringDetails.qmsScore),
          fsscScore: unwrapArray(resultedObj.scoringDetails.fsscScore),
        },
      };

      setViewFormData((prev) => {
        return {
          ...resultedObj,
          protocolDetails: {
            ...protocolObj,
          },
        };
      });
    }
  }, []);


  console.log("View Form Data:", viewFormData);

  return (
    <div className="max-w-8xl mx-auto p-6 min-h-screen">
      <div className="space-y-6">
        {/* Unit Details Section */}
        <AccordionSection title="Unit Details" sectionKey="unitDetails">
          {viewFormData &&
            viewFormData?.unitDetails?.unitDetails?.length > 0 ? (
            <>
              {renderTable(
                formDetails.unitDetails.unitDetails.filter(
                  (item) =>
                    item.name !== "responsibleDivisionId" &&
                    item.name !== "businessUnitId"
                ),
                "unitDetails"
              )}

              {viewFormData &&
                viewFormData.unitDetails.offSiteFields?.length > 0 && (
                  <div className="mt-6">
                    <h4 className="text-lg font-semibold text-gray-900 mb-4">
                      Off-Site Fields
                    </h4>
                    {renderTable(viewFormData.unitDetails.offSiteFields)}
                  </div>
                )}
            </>
          ) : (
            <div className="bg-yellow-50 border border-yellow-200 rounded-md p-4">
              <p className="text-yellow-800">
                No Unit Details Form Available As This Phase Is Not Yet Started
              </p>
            </div>
          )}
        </AccordionSection>

        {/* Audit Details Section */}
        <AccordionSection title="Audit Details" sectionKey="auditDetails">
          {viewFormData && viewFormData?.auditDetails?.length > 0 ? (
            <>
              {renderTable(
                viewFormData.auditDetails.filter((row) => {
                  // First filter out the standard excluded fields
                  if (["form_id", "audit_focus_area", "activity", "audit_team"].includes(row.name)) {
                    return false;
                  }

                  // Apply version-based filtering for Correction Date
                  const versionItem = viewFormData?.auditDetails?.find((item) => item.label === "Version");
                  const versionValue = versionItem ? parseInt(versionItem.value) : null;

                  if (versionValue === 1 && row.label === 'Correction Date') {
                    return false; // Hide Correction Date when version is 1
                  }

                  return true; // Show all other rows
                }),
                "auditDetails"
              )}

              {/* Audit Team Section */}
              {viewFormData &&
                viewFormData.auditDetails.find(
                  (row) => row.name === "audit_team"
                ) && (
                  <div className="mt-6">
                    <div className="flex items-center justify-between mb-4">
                      <h4 className="text-lg font-semibold text-gray-900">
                        Audit Team
                      </h4>
                      {/* <button
                      onClick={() => handleEdit(
                        'Audit Team',
                        JSON.stringify(formDetails.auditDetails.find((row) => row.name === "audit_team")?.value || {}),
                        'audit_team',
                        'auditDetails'
                      )}
                      className="text-blue-600 hover:text-blue-800 transition-colors"
                    >
                      <Edit2 size={16} />
                    </button> */}
                    </div>

                    <div className="overflow-x-auto">
                      <table className="min-w-full bg-white rounded-lg overflow-hidden shadow-sm">
                        <thead className="bg-gray-100">
                          <tr>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                              Additional Attendees
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                              Auditor Function
                            </th>
                          </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                          {Object.entries(
                            (viewFormData &&
                              viewFormData.auditDetails.find(
                                (row) => row.name === "audit_team"
                              )?.value) ||
                            {}
                          )
                            .sort(([, a], [, b]) =>
                              a === "Lead Auditor"
                                ? -1
                                : b === "Lead Auditor"
                                  ? 1
                                  : 0
                            )
                            .map(([key, value], index) => (
                              <tr
                                key={index}
                                className="hover:bg-gray-50 transition-colors"
                              >
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                  {key}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
                                  {value}
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}

              {/* Audit Focus Area Section */}
              {viewFormData &&
                viewFormData.auditDetails.some(
                  (row) =>
                    row.name === "audit_focus_area" && row.value?.length > 0
                ) && (
                  <div className="mt-6">
                    <h4 className="text-lg font-semibold text-gray-900 mb-4">
                      Audit Focus Area
                    </h4>
                    <div className="overflow-x-auto">
                      <table className="min-w-full bg-white rounded-lg overflow-hidden shadow-sm">
                        <thead className="bg-gray-100">
                          <tr>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                              Audit Focus Areas
                            </th>
                          </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                          {viewFormData &&
                            viewFormData.auditDetails
                              .find((row) => row.name === "audit_focus_area")
                              ?.value?.map((item, index) => (
                                <tr
                                  key={index}
                                  className="hover:bg-gray-50 transition-colors"
                                >
                                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                    {item}
                                  </td>
                                </tr>
                              ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
            </>
          ) : (
            <div className="bg-blue-50 border border-blue-200 rounded-md p-4">
              <p className="text-blue-800">Auditing in progress.</p>
            </div>
          )}
        </AccordionSection>

        {/* Protocol Details Section */}
        {viewFormData && viewFormData?.protocolDetails && (
          <AccordionSection
            title="Protocol Details"
            sectionKey="protocolDetails"
          >
            {/* Protocol Details Table */}

            {Object.keys(viewFormData.protocolDetails).length > 0 ? (
              <div className="space-y-6">
                <div className="overflow-x-auto">
                  <table className="min-w-full bg-white rounded-lg overflow-hidden shadow-sm">
                    <thead className="bg-gray-100">
                      <tr>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Field
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Response
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {viewFormData.protocolDetails?.protocolListArr &&
                        viewFormData.protocolDetails?.protocolListArr.map(
                          (proto, index) => (
                            <tr
                              key={proto.question_id}
                              className="hover:bg-gray-50 transition-colors"
                            >
                              <td className="px-6 py-4 whitespace-wrap text-sm font-medium text-gray-900 w-1/3">
                                {proto.text}
                              </td>
                              <td className="px-6 py-4 text-sm text-gray-700 w-2/3">
                                {proto.answer ? proto.answer : "N/A"}
                              </td>
                            </tr>
                          )
                        )}
                    </tbody>
                  </table>
                </div>

                {/* Areas of Concern */}
                {viewFormData &&
                  viewFormData.protocolDetails.areasOfConcern?.length > 0 && (
                    <div>
                      <h4 className="text-lg font-semibold text-gray-900 mb-4">
                        Areas of Concern - Findings Log
                      </h4>
                      <div className="overflow-x-auto">
                        <table className="min-w-full bg-white rounded-lg overflow-hidden shadow-sm">
                          <thead className="bg-gray-100">
                            <tr>
                              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Number (#)
                              </th>
                              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Standard
                              </th>
                              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Requirement
                              </th>
                              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Details
                              </th>
                              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Evidence
                              </th>
                              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Rating
                              </th>
                              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Status
                              </th>
                              {visible && (
                                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                  Evidence of Correction
                                </th>
                              )}
                            </tr>
                          </thead>
                          <tbody className="bg-white divide-y divide-gray-200">
                            {viewFormData &&
                              viewFormData.protocolDetails.areasOfConcern
                                .filter((item) => item.isPreviousYear === false)
                                .map((item, index) => (
                                  <tr
                                    key={index}
                                    className="hover:bg-gray-50 transition-colors"
                                  >
                                    <td className="px-4 py-4 text-sm text-gray-900">
                                      {item.number || "N/A"}
                                    </td>
                                    <td className="px-4 py-4 text-sm text-gray-700">
                                      {item.standardOrTechnicalSpecification ||
                                        "N/A"}
                                    </td>
                                    <td className="px-4 py-4 text-sm text-gray-700">
                                      {item.RequirementReference || "N/A"}
                                    </td>
                                    <td className="px-4 py-4 text-sm text-gray-700">
                                      {item.detailsOfNonconformity || "N/A"}
                                    </td>
                                    <td className="px-4 py-4 text-sm text-gray-700">
                                      {item.evidenceOfNonconformity || "N/A"}
                                    </td>
                                    <td className="px-4 py-4 text-sm">
                                      <span
                                        className={`px-2 py-1 text-xs font-semibold rounded-full ${item.nonconformityRating ===
                                          "Critical"
                                          ? "bg-[#fe0000]/10 text-[#fe0000]"
                                          : item.nonconformityRating ===
                                            "Major"
                                            ? "bg-[#ff8200]/10 text-[#ff8200]"
                                            : item.nonconformityRating ===
                                              "Minor"
                                              ? "bg-[#fede0f]/40 text-[#74681d]"
                                              : item.nonconformityRating ===
                                                "Opportunity for Improvement (OFI)"
                                                ? "bg-[#cbfe01] text-[green]-900"
                                                : "bg-gray-400 text-white"
                                          }`}
                                        title={item.nonconformityRating}
                                      >
                                        {(item.nonconformityRating === 'Opportunity for Improvement (OFI)' ? 'OFI' : item.nonconformityRating) || "N/A"}
                                      </span>
                                    </td>
                                    <td className="px-4 py-4 text-sm text-gray-700">
                                      {item.nonConformanceStatus || "N/A"}
                                    </td>
                                    {visible && (
                                      <td className="px-4 py-4 text-sm text-gray-700">
                                        {item.evidenceOfCorrection || "N/A"}
                                      </td>
                                    )}
                                  </tr>
                                ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}

                {viewFormData &&
                  viewFormData.protocolDetails.areasOfConcern?.length > 0 && (
                    <div>
                      <h4 className="text-lg font-semibold text-gray-900 mb-4">
                        Previous Year Non-conformity
                      </h4>
                      <div className="overflow-x-auto">
                        <table className="min-w-full bg-white rounded-lg overflow-hidden shadow-sm">
                          <thead className="bg-gray-100">
                            <tr>
                              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Number (#)
                              </th>
                              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Standard
                              </th>
                              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Requirement
                              </th>
                              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Details
                              </th>
                              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Evidence
                              </th>
                              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Rating
                              </th>
                              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Status
                              </th>
                              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Evidence of Correction
                              </th>
                            </tr>
                          </thead>
                          <tbody className="bg-white divide-y divide-gray-200">
                            {viewFormData &&
                              viewFormData.protocolDetails.areasOfConcern.filter(
                                (item) => item.isPreviousYear === true
                              ).length > 0 ? (
                              <>
                                {viewFormData &&
                                  viewFormData.protocolDetails.areasOfConcern
                                    .filter(
                                      (item) => item.isPreviousYear === true
                                    )
                                    .map((item, index) => (
                                      <tr
                                        key={index}
                                        className="hover:bg-gray-50 transition-colors"
                                      >
                                        <td className="px-4 py-4 text-sm text-gray-900">
                                          {item.number || "N/A"}
                                        </td>
                                        <td className="px-4 py-4 text-sm text-gray-700">
                                          {item.standardOrTechnicalSpecification ||
                                            "N/A"}
                                        </td>
                                        <td className="px-4 py-4 text-sm text-gray-700">
                                          {item.RequirementReference || "N/A"}
                                        </td>
                                        <td className="px-4 py-4 text-sm text-gray-700">
                                          {item.detailsOfNonconformity || "N/A"}
                                        </td>
                                        <td className="px-4 py-4 text-sm text-gray-700">
                                          {item.evidenceOfNonconformity ||
                                            "N/A"}
                                        </td>
                                        <td className="px-4 py-4 text-sm">
                                          <span
                                            className={`px-2 py-1 text-xs font-semibold rounded-full ${item.nonconformityRating ===
                                              "Critical"
                                              ? "bg-[#fe0000]/10 text-[#fe0000]"
                                              : item.nonconformityRating ===
                                                "Major"
                                                ? "bg-[#ff8200]/10 text-[#ff8200]"
                                                : item.nonconformityRating ===
                                                  "Minor"
                                                  ? "bg-[#fede0f]/40 text-[#74681d]"
                                                  : item.nonconformityRating ===
                                                    "Opportunity for Improvement (OFI)"
                                                    ? "bg-[#cbfe01] text-[green]-900"
                                                    : "bg-gray-400 text-white"
                                              }`}
                                            title={item.nonconformityRating}

                                          >
                                            {(item.nonconformityRating === 'Opportunity for Improvement (OFI)' ? 'OFI' : item.nonconformityRating) || "N/A"}
                                          </span>
                                        </td>
                                        <td className="px-4 py-4 text-sm text-gray-700">
                                          {item.nonConformanceStatus || "N/A"}
                                        </td>
                                        <td className="px-4 py-4 text-sm text-gray-700">
                                          {item.evidenceOfCorrection || "N/A"}
                                        </td>
                                      </tr>
                                    ))}
                              </>
                            ) : (
                              <tr>
                                <td
                                  colSpan="8"
                                  className="px-4 py-4 text-sm text-gray-700 text-center"
                                >
                                  No Previous Year Non-conformity
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}

                {/* FSSC */}
                {viewFormData &&
                  viewFormData.protocolDetails.ffscFindings?.length > 0 && (
                    <div>
                      <h4 className="text-lg font-semibold text-gray-900 mb-4">
                        FSSC Findings
                      </h4>
                      <div className="overflow-x-auto">
                        <table className="min-w-full bg-white rounded-lg overflow-hidden shadow-sm">
                          <thead className="bg-gray-100">
                            <tr>
                              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Number (#)
                              </th>
                              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Standard
                              </th>
                              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Requirement
                              </th>
                              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Details
                              </th>
                              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Evidence
                              </th>
                              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Rating
                              </th>
                              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Status
                              </th>
                              {visible && (
                                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                  Evidence of Correction
                                </th>
                              )}
                            </tr>
                          </thead>
                          <tbody className="bg-white divide-y divide-gray-200">
                            {viewFormData &&
                              viewFormData.protocolDetails.ffscFindings.filter(
                                (item) => item["Is Previous Year"] === false
                              ).length > 0 ? (
                              <>
                                {viewFormData &&
                                  viewFormData.protocolDetails.ffscFindings
                                    .filter(
                                      (item) =>
                                        item["Is Previous Year"] === false
                                    )
                                    .map((item, index) => (
                                      <tr
                                        key={index}
                                        className="hover:bg-gray-50 transition-colors"
                                      >
                                        <td className="px-4 py-4 text-sm text-gray-900">
                                          {item["Number (#)"] || "N/A"}
                                        </td>
                                        <td className="px-4 py-4 text-sm text-gray-700">
                                          {item[
                                            "Standard or Technical Specifications"
                                          ] || "N/A"}
                                        </td>
                                        <td className="px-4 py-4 text-sm text-gray-700">
                                          {item["Requirement Reference"] ||
                                            "N/A"}
                                        </td>
                                        <td className="px-4 py-4 text-sm text-gray-700">
                                          {item["Details of Nonconformity"] ||
                                            "N/A"}
                                        </td>
                                        <td className="px-4 py-4 text-sm text-gray-700">
                                          {item["Evidence of Non-conformity"] ||
                                            "N/A"}
                                        </td>
                                        <td className="px-4 py-4 text-sm">
                                          <span
                                            className={`px-2 py-1 text-xs font-semibold rounded-full ${item["Nonconformity Rating"] ===
                                              "Critical"
                                              ? "bg-[#fe0000]/10 text-[#fe0000]"
                                              : item["Nonconformity Rating"] ===
                                                "Major"
                                                ? "bg-[#ff8200]/10 text-[#ff8200]"
                                                : item["Nonconformity Rating"] ===
                                                  "Minor"
                                                  ? "bg-[#fede0f]/40 text-[#74681d]"
                                                  : item.nonconformityRating ===
                                                    "Opportunity for Improvement (OFI)"
                                                    ? "bg-[#cbfe01] text-green-700"
                                                    : "bg-gray-400 text-white"
                                              }`}
                                            title={item["Nonconformity Rating"]}

                                          >

                                            {(item["Nonconformity Rating"] === 'Opportunity for Improvement (OFI)' ? 'OFI' : item["Nonconformity Rating"]) || "N/A"}

                                          </span>
                                        </td>
                                        <td className="px-4 py-4 text-sm text-gray-700">
                                          {item["NonConformance Status"] ||
                                            "N/A"}
                                        </td>
                                        {visible && (
                                          <td className="px-4 py-4 text-sm text-gray-700">
                                            {item["Evidence Of Correction"] ||
                                              "N/A"}
                                          </td>
                                        )}
                                      </tr>
                                    ))}
                              </>
                            ) : (
                              <tr>
                                <td
                                  colSpan="8"
                                  className="px-4 py-4 text-sm text-gray-700 text-center"
                                >
                                  No FSSC Findings
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}

                {viewFormData &&
                  viewFormData.protocolDetails.ffscFindings?.length > 0 && (
                    <div>
                      <h4 className="text-lg font-semibold text-gray-900 mb-4">
                        Previous FSSC Findings{" "}
                      </h4>
                      <div className="overflow-x-auto">
                        <table className="min-w-full bg-white rounded-lg overflow-hidden shadow-sm">
                          <thead className="bg-gray-100">
                            <tr>
                              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Number (#)
                              </th>
                              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Standard
                              </th>
                              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Requirement
                              </th>
                              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Details
                              </th>
                              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Evidence
                              </th>
                              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Rating
                              </th>
                              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Status
                              </th>
                              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Evidence of Correction
                              </th>
                            </tr>
                          </thead>
                          <tbody className="bg-white divide-y divide-gray-200">
                            {viewFormData &&
                              viewFormData.protocolDetails.ffscFindings.filter(
                                (item) => item["Is Previous Year"] === true
                              ).length > 0 ? (
                              <>
                                {viewFormData &&
                                  viewFormData.protocolDetails.ffscFindings
                                    .filter(
                                      (item) =>
                                        item["Is Previous Year"] === true
                                    )
                                    .map((item, index) => (
                                      <tr
                                        key={index}
                                        className="hover:bg-gray-50 transition-colors"
                                      >
                                        <td className="px-4 py-4 text-sm text-gray-900">
                                          {item["Number (#)"] || "N/A"}
                                        </td>
                                        <td className="px-4 py-4 text-sm text-gray-700">
                                          {item[
                                            "Standard or Technical Specifications"
                                          ] || "N/A"}
                                        </td>
                                        <td className="px-4 py-4 text-sm text-gray-700">
                                          {item["Requirement Reference"] ||
                                            "N/A"}
                                        </td>
                                        <td className="px-4 py-4 text-sm text-gray-700">
                                          {item["Details of Nonconformity"] ||
                                            "N/A"}
                                        </td>
                                        <td className="px-4 py-4 text-sm text-gray-700">
                                          {item["Evidence of Non-conformity"] ||
                                            "N/A"}
                                        </td>
                                        <td className="px-4 py-4 text-sm">
                                          <span
                                            className={`px-2 py-1 text-xs font-semibold rounded-full ${"Critical"
                                              ? "bg-[#fe0000]/10 text-[#fe0000]"
                                              : item["Nonconformity Rating"] ===
                                                "Major"
                                                ? "bg-[#ff8200]/10 text-[#ff8200]"
                                                : item["Nonconformity Rating"] ===
                                                  "Minor"
                                                  ? "bg-[#fede0f]/40 text-[#74681d]"
                                                  : item.nonconformityRating ===
                                                    "Opportunity for Improvement (OFI)"
                                                    ? "bg-[#cbfe01] text-green-700"
                                                    : "bg-gray-400 text-white"
                                              }`}
                                            title={item["Nonconformity Rating"]}
                                          >
                                            {(item["Nonconformity Rating"] === 'Opportunity for Improvement (OFI)' ? 'OFI' : item["Nonconformity Rating"]) || "N/A"}

                                          </span>
                                        </td>
                                        <td className="px-4 py-4 text-sm text-gray-700">
                                          {item["NonConformance Status"] ||
                                            "N/A"}
                                        </td>
                                        <td className="px-4 py-4 text-sm text-gray-700">
                                          {item["Evidence Of Correction"] ||
                                            "N/A"}
                                        </td>
                                      </tr>
                                    ))}
                              </>
                            ) : (
                              <tr>
                                <td
                                  colSpan="8"
                                  className="px-4 py-4 text-sm text-gray-700 text-center"
                                >
                                  No Previous FSSC Findings
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
              </div>
            ) : (
              <div className="bg-blue-50 border border-blue-200 rounded-md p-4">
                <p className="text-blue-800">Protocol in progress.</p>
              </div>
            )}
          </AccordionSection>
        )}

        {/* Scoring Details Section */}
        {viewFormData && viewFormData?.scoringDetails && (
          <AccordionSection title="Scoring Details" sectionKey="scoringDetails">
            {Object.keys(viewFormData.scoringDetails).length > 0 ? (
              <div className="space-y-6">

                {formDetails.scoringDetails.qmsScore?.length > 0 && (
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-4">
                      QMS Results
                    </h4>


                    {renderTable(
                      formDetails.scoringDetails.qmsScore.filter((row) => {
                        return ![
                          "formId",
                          "id",
                          "isFfscCertificationRecommended",
                        ].includes(row.name);
                      })
                    )}
                  </div>
                )}


                {/* FSSC Score */}
                {formDetails &&
                  formDetails.scoringDetails.fsscScore?.length > 0 && (
                    <div>
                      <h4 className="text-lg font-semibold text-gray-900 mb-4">
                        FSSC Results
                      </h4>
                      {renderTable(
                        formDetails.scoringDetails.fsscScore.filter(
                          (row) => !["formId", "id"].includes(row.name)
                        )
                      )}
                    </div>
                  )}

                {/* Audit Conclusion */}
                {viewFormData &&
                  viewFormData.scoringDetails["Audit Conclusion"] && (
                    <div>
                      <h4 className="text-lg font-semibold text-gray-900 mb-4">
                        Audit Conclusion
                      </h4>
                      {renderTable(
                        viewFormData.scoringDetails["Audit Conclusion"].filter(
                          (row) =>
                            row.name !== "formId" &&
                            row.label !== "Is the Tech Review Done?"
                        )
                      )}
                    </div>
                  )}
              </div>
            ) : (
              <div className="bg-blue-50 border border-blue-200 rounded-md p-4">
                <p className="text-blue-800">Scoring in progress.</p>
              </div>
            )}
          </AccordionSection>
        )}
      </div>
    </div>
  );
};

export default FormViewDetails;
